import configs from "config";

type SupportCurrency = "ngn" | "ghs" | "kes" | "usd" | "xaf" | "xof" | 'cdf';

const currencyMap: Record<SupportCurrency, string> = {
  ngn: "en-NG",
  ghs: "en-GH",
  kes: "en-KE",
  usd: "en-US",

  xof: "ff-SN",
  xaf: "ff-CM",
  cdf: "ff-CD",
};

// const formatter = (currency: SupportCurrency, maximumSignificantDigits?: number) =>
//   new Intl.NumberFormat(currencyMap[currency], {
//     style: "currency",
//     currency: String(currency).toUpperCase(),
//     // maximumSignificantDigits
//     maximumSignificantDigits,

//     // These options are needed to round to whole numbers if that's what you want.
//     //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
//     //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
//   });


const formatter = (currency: SupportCurrency) => {
  const isFranc = configs.francoCoins.includes(currency);

  if (isFranc) {
    return {
      format(amount: number) {
        return String(currency + " ")
          .toUpperCase()
          .concat(numberWithCommas(MathRound(amount, 2).toString()));
      },
    };
  }

  return new Intl.NumberFormat(currencyMap[currency], {
    style: "currency",
    currency: String(currency).toUpperCase(),

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });
};

// const currencyFormat = (currency: SupportCurrency, digits?: any) => formatter(currency ?? 'ngn', digits);
const currencyFormat = (currency: SupportCurrency) => formatter(currency);


const toPrecision = (number: number | string, precision: number = 2) => {
  const num = Number(number);
  return Number(num.toFixed(precision));
};

const MathRound = (num: number, nrdecimals: number) => {
  let n = Number(Number(num).toFixed(nrdecimals));
  return (n > num ? toPrecision(n - 1 / Math.pow(10, nrdecimals), nrdecimals) : n).toFixed(nrdecimals) as unknown as number;
};

const numberWithCommas = (x: string) => {
  const parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};
export default currencyFormat;

